export default __webpack_public_path__ + "static/media/homeimage.f7d7b4cf.png";